import { render } from "./CompaniaFacturacion.vue?vue&type=template&id=1d6b1760"
import script from "./CompaniaFacturacion.vue?vue&type=script&lang=js"
export * from "./CompaniaFacturacion.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__